// Import useTranslation directly from react-i18next
// Import chat app translations
// Extend the core i18n with chat app translations
import { i18n } from '@doger/core/shared/i18n';

import enTranslations from './en.json';
import ukTranslations from './uk.json';

export { useTranslation } from 'react-i18next';

// Re-export core i18n functionality
export { I18nProvider, LanguageSwitcher } from '@doger/core/shared/i18n';

// Add chat app translations to the existing i18n instance
// Core translations are already loaded with 'core' namespace
// Chat translations will be loaded without namespace (default)
i18n.addResourceBundle('en', 'app', enTranslations, true, true);
i18n.addResourceBundle('uk', 'app', ukTranslations, true, true);

export { i18n };
